import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../DependencyHelper";
import formStyles from "../NewLineForms.module.scss";
import DropDown from "../dropDown/DropDown";
import { africaCountryCode } from "../../../../utils/helperServices";

const AuthenticationForm = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  idTypesOptions,
  countryTypesOptions,
  onChangeHandler,
  onBlurHandler,
  onResetHandler,
}) => {
  const handleChange = event => {
    onChangeHandler(event, null, formName);
  };
  const handleBlur = event => {
    onBlurHandler(event, null, formName);
  }

  const dropdownChangeHandler = (event, val=null, formName) => {
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  }

  return (
    <CustomContainer className={`${formStyles["main-container"]}`}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        <>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormaf101`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormaf101-label`}
            >
              ID type
            </Form.Label>
            <DropDown
              formName={formName}
              name="idType"
              label="ID type"
              data={idTypesOptions}
              handleSelect={onChangeHandler}
              handleReset={onResetHandler}
              resetRequired={true}
              selectedId={fieldValues["idType"]}
              customId={`validationFormaf101`}
              fieldError={fieldErrors["idType"]}
            />
            {fieldErrors["idType"] && (
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["idType"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          {fieldValues["idType"] == "PASSPORT" && (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormaf102`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormaf102-label`}
              >
                Passport number
              </Form.Label>
              <Form.Control
                type="text"
                name="passportNumber"
                value={fieldValues["passportNumber"]}
                placeholder="Enter your passport number"
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={fieldErrors["passportNumber"]}
                className={
                  fieldErrors["passportNumber"] ? formStyles["invalid"] : ""
                }
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["passportNumber"]}
              </Form.Control.Feedback>
            </Form.Group>
          )}
          {fieldValues["idType"] == "PASSPORT" && (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormaf103`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormaf103-label`}
              >
                Passport expiry date
              </Form.Label>
              <Form.Control
                type="text"
                name="passportExpiry"
                maxLength="14"
                value={fieldValues["passportExpiry"]}
                placeholder="DD / MM / YYYY"
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={fieldErrors["passportExpiry"]}
                className={
                  fieldErrors["passportExpiry"] ? formStyles["invalid"] : ""
                }
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["passportExpiry"]}
              </Form.Control.Feedback>
            </Form.Group>
          )}
          {fieldValues["idType"] == "PASSPORT" && (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormaf104`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormaf104-label`}
              >
                Country of origin
              </Form.Label>
              <DropDown
                formName={formName}
                label="Country of origin"
                name="countryOrigin"
                data={countryTypesOptions}
                handleSelect={dropdownChangeHandler}
                handleReset={onResetHandler}
                resetRequired={true}
                selectedId={fieldValues["countryOrigin"]}
                customId={`validationFormaf104`}
                fieldError={fieldErrors["countryOrigin"]}
              />

              {fieldErrors["countryOrigin"] && (
                <Form.Control.Feedback
                  type="invalid"
                  className={`${formStyles["invalid-feedback"]} d-block`}
                >
                  {fieldErrorsMessage["countryOrigin"]}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          )}
          {fieldValues["idType"] == "SAID" && (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormaf105`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormaf105-label`}
              >
                SA ID number
              </Form.Label>
              <Form.Control
                type="text"
                name="idNumber"
                value={fieldValues["idNumber"]}
                placeholder="Enter your ID number"
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={fieldErrors["idNumber"]}
                className={fieldErrors["idNumber"] ? formStyles["invalid"] : ""}
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["idNumber"]}
              </Form.Control.Feedback>
            </Form.Group>
          )}

          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormaf106`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormaf106-label`}
            >
              Cellphone number
            </Form.Label>
            <Form.Control
              type="text"
              maxLength={
                !africaCountryCode(fieldValues["cellNumber"]) ? "10" : "11"
              }
              name="cellNumber"
              value={fieldValues["cellNumber"]}
              placeholder="Enter your cellphone number"
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={fieldErrors["cellNumber"]}
              className={fieldErrors["cellNumber"] ? formStyles["invalid"] : ""}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["cellNumber"]}
            </Form.Control.Feedback>
            {!fieldErrors["cellNumber"] && (
              <div className={formStyles["hint-text"]}>
                {
                  "This is the number we’ll use to contact you regarding your account and/or deliveries"
                }
              </div>
            )}
          </Form.Group>
        </>
      </Form.Row>
    </CustomContainer>
  );
};

AuthenticationForm.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  onChangeHandler: PropTypes.func,
  onResetHandler: PropTypes.func,
  idTypesOptions: PropTypes.array,
  countryTypesOptions: PropTypes.array,
  onBlurHandler: PropTypes.func
};

AuthenticationForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  idTypesOptions: [],
  countryTypesOptions: [],
};

export default AuthenticationForm;
